const DATE_VARIALBES = {
    NINETY_DAYS_IN_MS: 90 * 24 * 60 * 60 * 1000,
    ONE_HOUR_IN_MS: 1 * 60 * 60 * 1000,
    TWENTY_FOUR_HOURS_IN_MS: 24 * 60 * 60 * 1000,
};

export default DATE_VARIALBES;